export default __webpack_public_path__ + "static/media/carousel4.b79c3afc.png";